import React from 'react';

const RouterOSVersionSelector = ({ value, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <button
          onClick={() => onChange('v6')}
          className={`p-6 rounded-xl border-2 transition-all ${
            value === 'v6'
              ? 'border-blue-500 bg-blue-50 shadow-lg'
              : 'border-gray-300 bg-white hover:border-blue-300'
          }`}
        >
          <div className="text-center">
            <div className="text-2xl font-bold text-gray-900 mb-2">RouterOS v6</div>
            <div className="text-sm text-gray-600">Versión estable</div>
          </div>
        </button>

        <button
          onClick={() => onChange('v7')}
          className={`p-6 rounded-xl border-2 transition-all ${
            value === 'v7'
              ? 'border-blue-500 bg-blue-50 shadow-lg'
              : 'border-gray-300 bg-white hover:border-blue-300'
          }`}
        >
          <div className="text-center">
            <div className="text-2xl font-bold text-gray-900 mb-2">RouterOS v7</div>
            <div className="text-sm text-gray-600">Versión moderna</div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default RouterOSVersionSelector;
